import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { EndPoints } from '../EndPoints';
import { DeliveryDetailDataForm } from '../../models/DeliveryDetail';

const useDeliveryDetailService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    // Estados de carga para cada operación
    const [fetchingGetDeliveryDetails, setFetchingGetDeliveryDetails] = useState(false);
    const [fetchingStoreDeliveryDetail, setFetchingStoreDeliveryDetail] = useState(false);
    const [fetchingEditDeliveryDetail, setFetchingEditDeliveryDetail] = useState(false);
    const [fetchingUpdateDeliveryDetail, setFetchingUpdateDeliveryDetail] = useState(false);
    const [fetchingDeleteDeliveryDetail, setFetchingDeleteDeliveryDetail] = useState(false);

    // GET - Listar detalles de una entrega
    const getDeliveryDetails = (deliveryId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.DELIVERY_DETAILS.GET_DELIVERY_DETAILS.replace(':delivery_id', deliveryId.toString()),
            setFetching: setFetchingGetDeliveryDetails
        });
    };

    // POST - Crear detalle
    const storeDeliveryDetail = (deliveryId: number, detail: DeliveryDetailDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.DELIVERY_DETAILS.STORE_DELIVERY_DETAIL.replace(':delivery_id', deliveryId.toString()),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            body: detail,
            setFetching: setFetchingStoreDeliveryDetail
        });
    };

    // GET - Obtener detalle para editar
    const editDeliveryDetail = (deliveryId: number, detailId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.DELIVERY_DETAILS.EDIT_DELIVERY_DETAIL
                .replace(':delivery_id', deliveryId.toString())
                .replace(':id', detailId.toString()),
            setFetching: setFetchingEditDeliveryDetail
        });
    };

    // PUT - Actualizar detalle
    const updateDeliveryDetail = (
        deliveryId: number,
        detailId: number,
        detail: DeliveryDetailDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.DELIVERY_DETAILS.UPDATE_DELIVERY_DETAIL
                .replace(':delivery_id', deliveryId.toString())
                .replace(':id', detailId.toString()),
            body: detail,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            requestType: 'json',
            setFetching: setFetchingUpdateDeliveryDetail
        });
    };

    // DELETE - Eliminar detalle
    const deleteDeliveryDetail = (deliveryId: number, detailId: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.DELIVERY_DETAILS.DELETE_DELIVERY_DETAIL
                .replace(':delivery_id', deliveryId.toString())
                .replace(':id', detailId.toString()),
            setFetching: setFetchingDeleteDeliveryDetail
        });
    };

    return {
        fetchingGetDeliveryDetails,
        fetchingStoreDeliveryDetail,
        fetchingEditDeliveryDetail,
        fetchingUpdateDeliveryDetail,
        fetchingDeleteDeliveryDetail,
        getDeliveryDetails,
        storeDeliveryDetail,
        editDeliveryDetail,
        updateDeliveryDetail,
        deleteDeliveryDetail
    };
};

export default useDeliveryDetailService;
